import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import DstButton from "../../../../../components/DstButton/DstButton";
import translate from "../../../../../services/Translate";
import { completeNavigate } from "../../../../../services/UtilityService";
import { fetchProjectSubjectResources } from "../../../Project.function";

const ProjectResources = ({ project, language }: { project: any; language: string }) => {
  const [resources, setResources] = useState<any[]>([]);
  const [resourcesLoaded, setResourcesLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!project?.subject?.id) return;

    fetchProjectSubjectResources(project.subject.id, setResources, setResourcesLoaded, language);
  }, [project?.subject?.id, language]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center m-regular mt-4 my-3">
        <div>{translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.SECTIONS.RESOURCES")}</div>

        <div className="d-flex gap-2">
          <DstButton
            variant="secondary"
            value={translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.RESOURCES.ACTIONS.MANAGE_RESOURCES")}
            btnImageBefore={<span className="dst-icon-edit-02 me-2" />}
            clickFunction={(event: React.MouseEvent) =>
              completeNavigate(event, navigate, `/projects/subjects/${project.subject.id}`)
            }
          />
        </div>
      </div>

      {!resourcesLoaded &&
        Array.from({ length: 3 }).map((_: any, index: number) => (
          <div
            key={`loading-resource-${index}`}
            className="d-flex s-regular mb-2 justify-content-between border-bottom pb-2"
          >
            <div className="d-flex">
              <div className="dst-icon-link-01 text-muted me-2 mt-1" />
              <div>
                <div className="bg-light rounded" style={{ width: 140, height: 14 }} />
                <div className="bg-light rounded mt-1" style={{ width: 220, height: 12 }} />
              </div>
            </div>
          </div>
        ))}

      {resourcesLoaded && resources.length === 0 && (
        <div className="text-muted">{translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.RESOURCES.EMPTY")}</div>
      )}

      {resourcesLoaded &&
        resources.map((resource: any) => (
          <div key={resource.id} className="d-flex s-regular mb-2 justify-content-between border-bottom pb-2">
            <div className="d-flex">
              <div className="dst-icon-link-01 blue-font me-2 mt-1" />
              <div>
                <div>{resource.name}</div>
                {resource.url && (
                  <div className="text-muted">
                    <a href={resource.url} target="_blank" rel="noreferrer" className="text-decoration-none">
                      {resource.url}
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default ProjectResources;
